import { render, staticRenderFns } from "./MarkHelpPage.vue?vue&type=template&id=f34bf084&scoped=true&"
import script from "./MarkHelpPage.vue?vue&type=script&lang=js&"
export * from "./MarkHelpPage.vue?vue&type=script&lang=js&"
import style0 from "./MarkHelpPage.vue?vue&type=style&index=0&id=f34bf084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34bf084",
  null
  
)

export default component.exports